/**
 * Tabla de atendidos de la sede activa (presentacional).
 *
 * Réplica de `atendidos.html` del SSR (`progress/explore_admin_ssr.md`): nombre,
 * sede, estado (activo/inactivo) y acciones Editar/Eliminar por fila. Sin lógica
 * de datos: recibe los atendidos y notifica las acciones al padre. El listado lo
 * acota la sede activa (`X-Sede-Id`), igual que el SSR filtra por la sede de la
 * sesión.
 */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@/components/ui";

import type { AtendidoListItem } from "../types";

interface AtendidosTableProps {
  atendidos: AtendidoListItem[];
  onEdit: (atendido: AtendidoListItem) => void;
  onDelete: (atendido: AtendidoListItem) => void;
}

export function AtendidosTable({ atendidos, onEdit, onDelete }: AtendidosTableProps) {
  if (atendidos.length === 0) {
    return (
      <p className="px-1 py-8 text-center text-sm text-slate-500">
        No hay atendidos registrados en esta sede.
      </p>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Nombre</TableHeaderCell>
          <TableHeaderCell>Sede</TableHeaderCell>
          <TableHeaderCell>Estado</TableHeaderCell>
          <TableHeaderCell className="text-right">Acciones</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {atendidos.map((atendido) => (
          <TableRow key={atendido.id}>
            <TableCell>
              <span className="font-medium text-slate-900">{atendido.nombre}</span>
            </TableCell>
            <TableCell>{atendido.sede?.nombre ?? "—"}</TableCell>
            <TableCell>
              {atendido.activo ? (
                <span className="inline-flex items-center rounded bg-emerald-100 px-1.5 py-0.5 text-xs font-medium text-emerald-700">
                  Activo
                </span>
              ) : (
                <span className="inline-flex items-center rounded bg-slate-100 px-1.5 py-0.5 text-xs font-medium text-slate-600">
                  Inactivo
                </span>
              )}
            </TableCell>
            <TableCell>
              <div className="flex flex-wrap justify-end gap-1">
                <Button
                  type="button"
                  variant="secondary"
                  size="sm"
                  onClick={() => onEdit(atendido)}
                >
                  Editar
                </Button>
                <Button
                  type="button"
                  variant="danger"
                  size="sm"
                  onClick={() => onDelete(atendido)}
                >
                  Eliminar
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
